<template>
	<div>
		<div class="container">
			<div class="handle-box">
			
				<el-button size="small" type="primary" :class="[theme]" @click="showAddVisible">添加</el-button>
			</div>

			<div style="width: 100%;height: 20px;clear: both;"></div>
			<el-row :gutter="20" type="flex" class="row-bg">
				<el-col :span="24">
					<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
						:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
						<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
						<el-table-column prop="standard" label="制式" align="center"></el-table-column>
						<el-table-column prop="num" label="接通频次" align="center"></el-table-column>
						<el-table-column label="操作" align="center">
							<template #default="scope">
								<el-button size="small" type="text" icon="el-icon-edit"
									@click="handleEdit(scope.row)">编辑</el-button>
								<el-button size="small" type="text" icon="el-icon-delete" style="color: #f56c6c;"
									@click="handleDelete(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</div>
		<el-dialog title="添加" v-model="addVisible" width="450px" :close-on-click-modal="false">
			<el-form :model="addForm" ref="addForm" label-width="120px">
				<el-form-item label="接通频次">
					<el-input size="small" type="text" placeholder="请输入接通频次" v-model="addForm.num"></el-input>
				</el-form-item>
				<el-form-item label="品牌">
					<el-select size="small" v-model="addForm.cardId" clearable filterable placeholder="请选择"
						style="width: 100%;">
						<el-option v-for="item in cardTypeList" :key="item.value" :label="item.value"
							:value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="制式">
					<el-select size="small" v-model="addForm.standard" clearable filterable placeholder="请选择制式"
						style="width: 100%;">
						<el-option v-for="item in standardList" :key="item.label" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="addClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getForewarningAdd">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="编辑" v-model="editVisible" width="450px" :close-on-click-modal="false">
			<el-form :model="editForm" ref="editForm" label-width="120px">
				<el-form-item label="接通频次">
					<el-input size="small" type="text" placeholder="请输入接通频次" v-model="editForm.num"></el-input>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="editClose">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="getForewarningUpdate">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	import {
		forewarningList,
		forewarningAdd,
		forewarningDelete,
		forewarningUpdate,
		dxtLimitCall,
		deliveryLimitList,
		deliveryLimitUpdate,
		addDeliveryLimit,
		deleteDeliveryLimit,
		InventoryByProvince
	} from '../../api/SjtxCard.js';
	import {
		getCardType
	} from '../../api/cardType.js';
	export default {
		name: 'frequencyLimiting',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {

				},
				tableData: [],
				pageTotal: 0,
				multipleSelection: [],
				typeList: [{
						value: '1',
						label: '基础预警',
					},
					{
						value: '2',
						label: '指定城市',
					},
				],
				cardTypeList: [],
				addForm: {
					num: '',
					cardId: '',
					standard: ''
				},
				editForm: {
					num: '',
					id: '',
				},
				uploadData: {
					userId: localStorage.getItem('user')
				},
				path: process.env.BASE_URL,
				addVisible: false,
				editVisible: false,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},


				standardList: [{
						value: '联通',
						label: '联通',
					},
					{
						value: '电信',
						label: '电信',
					},
					{
						value: '移动',
						label: '移动',
					}
				],
			};
		},
		created() {
			this.getCardType();
			this.getData();
		},
		methods: {
			//获取品牌和品牌里面的套餐
			getCardType(item) {
				getCardType('').then(res => {
					this.cardTypeList = res.data;
				})
			},

			getData() {
				this.loading = true;
				deliveryLimitList().then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			//添加
			showAddVisible() {
				this.addVisible = true;
				this.addForm.num = '';
				this.addForm.cardId = '';
				this.addForm.standard = '';
			},
			getForewarningAdd() {
				addDeliveryLimit(this.addForm).then(res => {
					if (res?.code === 200) {
						this.addVisible = false;
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},

			//关闭出库弹窗
			addClose() {
				this.addVisible = false;
			},
			//关闭出库弹窗
			editClose() {
				this.editVisible = false;
			},
			//编辑
			handleEdit(row) {
				this.editVisible = true;
				this.editForm.num = row.num;
				this.editForm.id = row.id;
			},
			getForewarningUpdate() {

				deliveryLimitUpdate(this.editForm).then(res => {
					if (res?.code === 200) {
						this.editVisible = false;
						this.$message.success(res.data);
						this.getData();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleDelete(row) {
				this.$confirm('确定要删除吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						let data = {
							id: row.id
						}
						deleteDeliveryLimit(data).then(res => {
							if (res?.code === 200) {
								this.$message.success('删除成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					})
					.catch(() => {});
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			//下一页
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.getData();
			},
			//获取库存城市列表
			getSJSZInventoryStatistics() {
				this.query.city = '';
				let data = {
					province: this.query.province,
					city: this.query.city,
					standard: this.query.standard,
					cardId: this.query.cardId,
					setMealId: this.query.setMealId,
				};
				InventoryByProvince(data).then(res => {
					if (res?.code === 200) {
						this.cityList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},


		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 50px;
	}

	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mt10 {
		margin-top: 10px;
	}
</style>